type AdminSection = 'overview' | 'quotes' | 'bookings' | 'services' | 'customers'

interface AdminSidebarProps {
  active: AdminSection
}

const navItems: Array<{ id: AdminSection; label: string; href: string }> = [
  { id: 'overview', label: 'Overview', href: '/admin' },
  { id: 'quotes', label: 'Enquiries', href: '/admin/quotes' },
  { id: 'bookings', label: 'Bookings', href: '/admin/bookings' },
  { id: 'services', label: 'Services', href: '/admin/services' },
  { id: 'customers', label: 'Customers', href: '/admin/customers' },
]

export function AdminSidebar({ active }: Readonly<AdminSidebarProps>) {
  return (
    <aside className="admin-sidebar">
      <a href="/" aria-label="Autoglow home"><img src="/images/autoglow-logo.svg" alt="Autoglow Detailing Logo" /></a>
      <p>COMMAND CENTER</p>
      <nav>
        {navItems.map((item) => (
          <a className={active === item.id ? 'active' : undefined} href={item.href} key={item.id}>
            {item.label}
          </a>
        ))}
        <a href="/">Website</a>
      </nav>
    </aside>
  )
}
